import { AppLogType } from '../types';

let dispatchRef: any = null;

export const setLogDispatch = (dispatch: any) => {
  dispatchRef = dispatch;
};

export const logSSOError = (operation: string, error: any, uid: string | null) => {
  if (dispatchRef) {
    dispatchRef({
      type: 'SEND_LOG',
      payload: {
        logEvent: AppLogType.SSO_ERROR,
        logType: 'error',
        logMessage: `SSO ${operation} token failed`,
        logDetails: {
          httpStatus: error?.response?.status,
          errorMessage: error instanceof Error ? error.message : 'Unknown error',
          uid,
          hasApigeeUrl: !!sessionStorage.getItem('APIGEE_BASE_URL'),
        }
      }
    });
  }
};